import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";
import Index from "./views/Gdewe/index.vue";
import { $qu } from "./utils/auth.js";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new Router({
  mode:"history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
    },
	{
	  path: "/search",
	  name: "search",
	  component: () => import("./views/Gdewe/Search/search.vue"),
	},
	// 聚合
	{
		path: "/aggregation",
		name: "aggregation",
		component: () => import("./views/Gdewe/Product/aggregation.vue"),
		
	},
    {
      path: "/activity",
      name: "activity",
      component: () => import("./views/Gdewe/Activity/activity.vue"),
    },
	{
	  path: "/forum",
	  name: "forum",
	  component: () => import("./views/Gdewe/Forum/forum.vue"),
	},
	{
	  path: "/forum/forum_details/:id",
	  name: "forum_details",
	  component: () => import("./views/Gdewe/Forum/forum_details.vue"),
	},
	{
	  path: "/preview_details",
	  name: "preview_details",
	  component: () => import("./views/Gdewe/Forum/preview_details.vue"),
	},
	
    {
      path: "/forum/group/:id",
      name: "group",
      component: () => import("./views/Gdewe/Forum/group.vue"),
    },
    {
      path: "/forum/post/:id?",
      name: "post",
      component: () => import("./views/Gdewe/Forum/post.vue"),
    },
	// <!-- 改跳转链接 -->
    {
      path: "/forum/details/:id",
      name: "details",
      component: () => import("./views/Gdewe/Forum/details.vue"),
    },
    {
      path: "/LearningLab",
      name: "LearningLab",
      component: () => import("./views/Gdewe/Resource/resource.vue"),
    },
    {
      path: "/LearningLab/webinar-details/:id",
      name: "webinar-details",
      component: () => import("./views/Gdewe/Resource/webinar-details.vue"),
    },
    {
      path: "/webinar",
      name: "webinar",
      component: () => import("./views/Gdewe/Resource/webinar.vue"),
    },
    {
      path: "/LearningLab/blog-details/:id",
      name: "blog-details",
      component: () => import("./views/Gdewe/Resource/blog-details.vue"),
    },
    {
      path: "/blog",
      name: "blog",
      component: () => import("./views/Gdewe/Resource/blog.vue"),
    },
    {
      path: "/LearningLab/video-details/:id",
      name: "video-details",
      component: () => import("./views/Gdewe/Resource/video-details.vue"),
    },
    {
      path: "/video",
      name: "video",
      component: () => import("./views/Gdewe/Resource/video.vue"),
    },
    {
      path: "/LearningLab/Playlists-details/:id",
      name: "Playlists-details",
      component: () => import("./views/Gdewe/Resource/Playlists-details.vue"),
    },
    {
      path: "/plus_detail",
      name: "plus_detail",
      component: () => import("./views/Gdewe/Plus/plus_detail.vue"),
    },
	{
	  path: "/collect_points",
	  name: "collect_points",
	  component: () => import("./views/Gdewe/Plus/collect_points.vue"),
	},
	
	{
	  path: "/lynx-U-Battery-expansion-program",
	  name: "lynx-U-Battery-expansion-program",
	  component: () => import("./views/Gdewe/Plus/Promotion"),
	},
	
    {
      path: "/plus_center",
      name: "plus_center",
      component: () => import("./views/Gdewe/Plus/plus_center.vue"),
    },
    {
      path: "/plus_centerList",
      name: "plus_centerList",
      component: () => import("./views/Gdewe/Plus/plus_centerList.vue"),
    },
    {
      path: "/plus_details",
      name: "plus_details",
      component: () => import("./views/Gdewe/Plus/plus_details.vue"),
    },
    {
      path: "/plus",
      name: "plus",
      component: () => import("./views/Gdewe/Plus/plus.vue"),
    },
	{
	  path: "/pointsMall",
	  name: "pointsMall",
	  component: () => import("./views/Gdewe/PointsMall/pointsMall.vue"),
	},
	{
	  path: "/pointsMall/exchange/:id",
	  name: "exchange",
	  component: () => import("./views/Gdewe/PointsMall/exchange.vue"),
	},
	{
	  path: "/extended",
	  name: "extended",
	  component: () => import("./views/Gdewe/PointsMall/extended.vue"),
	},
	
	{
	  path: "/pointsMall/results/:id",
	  name: "results",
	  component: () => import("./views/Gdewe/PointsMall/exresults.vue"),
	},
	{
	  path: "/pointsMall/address",
	  name: "address",
	  component: () => import("./views/Gdewe/PointsMall/address.vue"),
	},
	{
	  path: "/pointsMall/myOrder",
	  name: "myOrder",
	  component: () => import("./views/Gdewe/PointsMall/myOrder.vue"),
	},
	{
	  path: "/pointsMall/warranty",
	  name: "warranty",
	  component: () => import("./views/Gdewe/PointsMall/warranty.vue"),
	},
	{
	  path: "/register",
	  name: "register",
	  component: () => import("./views/Gdewe/Login/register.vue"),
	},
	{
	  path: "/login_in",
	  name: "login_in",
	  component: () => import("./views/Gdewe/Login/login_in.vue"),
	},
	{
	  path: "/login_plus",
	  name: "login_plus",
	  component: () => import("./views/Gdewe/Login/login_plus.vue"),
	},
    {
      path: "/login/SEMS",
      name: "login",
      component: () => import("./views/Gdewe/Login/login.vue"),
    },
    {
      path: "/index3",
      name: "index3",
      component: () => import("./views/Gdewe/index3.vue"),
    },
    {
      path: "/index4",
      name: "index4",
      component: () => import("./views/Gdewe/index4.vue"),
    },
    {
      path: "/PVSizingTool",
      name: "PVSizingTool",
      component: () => import("./views/Gdewe/proComSystem/proComOne.vue"),
    },
    {
      path: "/proComTwo",
      name: "proComTwo",
      component: () => import("./views/Gdewe/proComSystem/proComTwo.vue"),
    },
    {
      path: "/proComThre",
      name: "proComThre",
      component: () => import("./views/Gdewe/proComSystem/proComThre.vue"),
    },
	{
	  path: "/proComFour",
	  name: "proComFour",
	  component: () => import("./views/Gdewe/proComSystem/proComFour.vue"),
	},
    {
      path: "/user-Profile",
      name: "user-Profile",
      component: () => import("./views/Gdewe/Personal/user-Profile.vue"),
    },
	{
	  path: "/privateAgreement",
	  name: "privateAgreement",
	  component: () => import("./views/Gdewe/Personal/yinsixieyi.vue"),
	},
	{
	  path: "/userAgreement",
	  name: "userAgreement",
	  component: () => import("./views/Gdewe/Personal/userAgreement.vue"),
	},
	{
	  path: "/Lynx-U-Battery-Exchange-Promotion-Terms-Conditions",
	  name: "Lynx-U-Battery-Exchange-Promotion-Terms-Conditions",
	  component: () => import("./views/Gdewe/Personal/userAgreement2.vue"),
	},
	
	{
	  path: "/coinAgreement",
	  name: "coinAgreement",
	  component: () => import("./views/Gdewe/Personal/coinAgreement.vue"),
	},
	
	{
	  path: "/exam",
	  name: "exam",
	  component: () => import("./views/Gdewe/exam/exam.vue"),
	},
	{
	  path: "/exam/examQuestions",
	  name: "examQuestions",
	  component: () => import("./views/Gdewe/exam/examQuestions.vue"),
	},
	{
    path: "/exam/examQuestionsEnd/:id",
    name: "examQuestionsEnd",
    component: () => import(/* webpackChunkName: "exam" */ "./views/Gdewe/exam/examQuestionsEnd.vue"),
  },
  {
    path: "/exam/examResults/:id",
    name: "examResults", 
    component: () => import(/* webpackChunkName: "exam" */ "./views/Gdewe/exam/examResults.vue"),
  }
  ],
  scrollBehavior(to, from, savedPosition) {
      // 总是滚动到顶部
      return { x: 0, y: 0 };
    }
});







export default router;
